export const VNMobilePhonePattern =
  /^(0)((3[0-9])|(5[0-9])|(7[0-9])|(8[0-9])|(9[0-9]))(\d{7})$/;
